<div class="layout">
    <div>
        <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Debtor distributions</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <app-mat-table-generator #matTable [tableName]="'debtorDistributionsTable'"
            [multiselectEnabled]="false" 
            [searchEnabled]="false"
            [columns]="debtorDistributionsColumns" 
            [dataSource]="debtorDistributionsDataSource" 
            [viewLink]="getViewLink">
          </app-mat-table-generator>
        </mat-card-content>
      </mat-card>
    </div>
    <div>
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Debtors service logs</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <app-mat-table-generator #matTable [tableName]="'debtorsTable'"
            [multiselectEnabled]="false"
            [columns]="debtorsColumns" [dataSource]="debtorsDataSource">
          </app-mat-table-generator>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
